var _defs, _use, _mask, _use2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClubStripBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 398,
    viewBox: "0 0 320 398",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qayu612tpa",
    d: "M0 0h320v316H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hchel2rjtb",
    d: "M0 0h320v398H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#F3F4F7",
    xlinkHref: "#qayu612tpa"
  })), /*#__PURE__*/React.createElement("g", null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "bkebdh8svc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hchel2rjtb"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#2E2D79",
    xlinkHref: "#hchel2rjtb"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.849,
    mask: "url(#bkebdh8svc)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.717
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.504,
    fill: "#9C9C9C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "rotate(-62.157 -103.24 1300.062)",
    d: "m226.43 233.995 1086.743 780.635 131.41 362.322L357.838 596.316z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "rotate(-62.153 56.493 1417.567)",
    d: "m718.065 715.327 546.096 392.26 8.32 22.931-546.095-392.26z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "rotate(-62.115 376.752 1222.723)",
    d: "m1041.518 528.297 546.659 392.652 2.082 5.733L1043.6 534.03z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "rotate(-62.153 -210.548 1257.88)",
    d: "m140.444 250.148 1086.462 780.447 89.115 245.729-1086.46-780.447z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubStripBgMobile);
export default __webpack_public_path__ + "static/media/club-strip-bg-mobile.34644122411688209007906beb8f734a.svg";
export { ForwardRef as ReactComponent };